var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSellUsedDevices = function SvgSellUsedDevices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 60,
    r: 2,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M50.5 31a1 1 0 0 0-1 1v32a5 5 0 0 1-5 5h-20a5 5 0 0 1-5-5V16a5 5 0 0 1 5-5h20a5 5 0 0 1 5 5 1 1 0 0 0 2 0 7 7 0 0 0-7-7h-20a7 7 0 0 0-7 7v48a7 7 0 0 0 7 7h20a7 7 0 0 0 7-7V32a1 1 0 0 0-1-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M61.5 20c-5.21 0-6-.79-6-6a1 1 0 0 0-2 0c0 5.21-.79 6-6 6a1 1 0 0 0 0 2c5.21 0 6 .79 6 6a1 1 0 0 0 2 0c0-5.21.79-6 6-6a1 1 0 0 0 0-2m-7 2.48A4.2 4.2 0 0 0 53 21a4.2 4.2 0 0 0 1.48-1.48A4.2 4.2 0 0 0 56 21a4.2 4.2 0 0 0-1.5 1.48M51 27c-2.34 0-2.5-.16-2.5-2.5a1 1 0 0 0-2 0c0 2.34-.16 2.5-2.5 2.5a1 1 0 0 0 0 2c2.34 0 2.5.16 2.5 2.5a1 1 0 0 0 2 0c0-2.34.16-2.5 2.5-2.5a1 1 0 0 0 0-2"
  })));
};
export default SvgSellUsedDevices;